// The bootstrapping and index file have to be separated.
// If they are not separated, the application will not work when deployed due to a timing and loading issue.
import('./bootstrap');